interface Props {
	/** Plural noun for what failed to load, e.g. "pages", "hashtags". */
	noun: string;
	onRetry?: () => unknown;
	/** So the search field can be described by it (aria-describedby). */
	id?: string;
}

/**
 * The failed-search state every link picker shares: says the results could
 * not be loaded (rather than showing an empty list that reads as "no
 * matches") and offers a retry.
 */
const PickerLoadError = ({ noun, onRetry, id }: Props) => (
	<p id={id} role="alert" className="text-caption text-destructive">
		Couldn&apos;t load {noun}.{" "}
		<button
			type="button"
			onClick={() => onRetry?.()}
			className="rounded-sm text-link underline underline-offset-2 hover:opacity-80 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1"
		>
			Try again
		</button>
	</p>
);

export default PickerLoadError;
